import { createContext } from "react";
const AnimationDriverContext = createContext(null);
export {
  AnimationDriverContext
};
//# sourceMappingURL=AnimationDriverContext.js.map
